import { MarkdownPre } from './blocks/markdown-pre';
import { MarkdownComponents } from './types';

const browser = {
  h1: ({ children }) => (
    <h1 className="mm:scroll-m-20 mm:text-4xl mm:font-extrabold mm:tracking-tight mm:lg:text-5xl mm:mb-4">
      {children}
    </h1>
  ),
  h2: ({ children }) => (
    <h2 className="mm:scroll-m-20 mm:border-b mm:pb-2 mm:text-3xl mm:font-semibold mm:tracking-tight mm:transition-colors mm:first:mt-0 mm:mb-4">
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3 className="mm:scroll-m-20 mm:text-2xl mm:font-semibold mm:tracking-tight mm:mb-4">
      {children}
    </h3>
  ),
  h4: ({ children }) => (
    <h4 className="mm:scroll-m-20 mm:text-xl mm:font-semibold mm:tracking-tight mm:mb-4">
      {children}
    </h4>
  ),
  p: ({ children }) => (
    <p className="mm:leading-7 mm:[&:not(:first-child)]:mt-6">{children}</p>
  ),
  ul: ({ children }) => (
    <ul className="mm:m-6 mm:list-disc mm:[&>li]:mt-2">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="mm:my-6 mm:ml-6 mm:list-decimal mm:[&>li]:mt-2">
      {children}
    </ol>
  ),
  blockquote: ({ children }) => (
    <blockquote className="mm:mt-6 mm:border-l-2 mm:pl-6 mm:italic">
      {children}
    </blockquote>
  ),
  a: ({ children, href }) => (
    <a
      href={href}
      className="mm:font-medium mm:text-primary mm:underline mm:underline-offset-4"
    >
      {children}
    </a>
  ),
  code: ({ children, className = '' }) => (
    <code
      className={
        className +
        ' mm:relative mm:rounded mm:bg-muted mm:px-[0.3rem] mm:py-[0.2rem] mm:font-mono mm:text-sm mm:font-semibold'
      }
    >
      {children}
    </code>
  ),
  pre: ({ children }) => (
    <MarkdownPre className="mm:mb-4 mm:mt-6 mm:overflow-x-auto mm:rounded-lg mm:bg-black mm:p-4">
      {children}
    </MarkdownPre>
  ),
} as MarkdownComponents;

export const components: MarkdownComponents = browser;
